'use client';

// import { tsRestFetchApi } from '@ts-rest/core';
import { tsRestFetchApi } from '@ts-rest/core';
import { initTsrReactQuery } from '@ts-rest/react-query/v5';
import { getAuth } from 'firebase/auth';

import { TsRestConfig } from '@/configs/ts-rest.config';

import { CandidateApiContracts, SharedApiContracts } from '@packages/contracts';

import { app } from '../firebase/firebase';

async function _getToken(): Promise<null | string> {
	const auth = getAuth(app);
	const user = auth.currentUser;

	return user ? user.getIdToken() : null;
}

export const tsr = initTsrReactQuery(CandidateApiContracts, {
	baseUrl: TsRestConfig.baseUrl,

	baseHeaders: {
		'Content-Type': 'application/json',
		'x-app-source': 'ts-rest',
	},
	api: async (options) => {
		const token = await _getToken();

		return tsRestFetchApi({
			...options,
			headers: {
				...options.headers,
				...(token ? { authorization: `Bearer ${token}` } : {}),
			},
		});
	},
});

export const tsrShared = initTsrReactQuery(SharedApiContracts, {
	baseUrl: TsRestConfig.baseUrl,

	baseHeaders: {
		'Content-Type': 'application/json',
		'x-app-source': 'ts-rest',
	},
});
